// extracted by mini-css-extract-plugin
export default {"wrapperHr":"login-screen_wrapperHr__ToTTz"};